import { gateKeeperAllowsAbility } from '@/middleware/GateKeeperMiddleware.js';
import GateKeeper from '@/plugins/vue-gate/GateKeeper.js';

/**
 * The ability every Inbox route requires through GateKeeperMiddleware (the `view all messages` permission).
 */
export const INBOX_ABILITY = Object.freeze({ action: 'view all', subject: 'messages' });

// Navigation projection of the Inbox routes' gate; the API independently authorizes every call.
export function canViewInbox(user) {
    if (!user) {
        return false;
    }

    return gateKeeperAllowsAbility(new GateKeeper().forUser(user), INBOX_ABILITY);
}
